import React from 'react';
import { Users, Target, Award, Heart } from 'lucide-react';
export function AboutSection() {
  return <section className="bg-dark-700 py-[80px] px-5" id="nosotros" data-id="element-21">
      <div className="max-w-[1100px] mx-auto" data-id="element-22">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white" data-id="element-23">
          Quiénes Somos
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-24">
          Conocé la historia detrás de AlphaFit
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center" data-id="element-25">
          <div data-id="element-26">
            <p className="text-[#ccc] text-[1.05rem] leading-[1.9] mb-6" data-id="element-27">
              En <strong className="text-white" data-id="element-28">AlphaFit</strong> nacimos con
              una misión clara: hacer que los suplementos de calidad sean
              accesibles para todos los deportistas en Uruguay.
            </p>
            <p className="text-[#ccc] text-[1.05rem] leading-[1.9] mb-6" data-id="element-29">
              Trabajamos con marcas como{' '}
              <strong className="text-white" data-id="element-30">Cibeles y Profit</strong> porque
              creemos que no deberías elegir entre calidad y precio. Cada
              producto que ofrecemos está respaldado por fórmulas probadas y
              resultados reales.
            </p>
            <p className="text-[#ccc] text-[1.05rem] leading-[1.9]" data-id="element-31">
              Con{' '}
              <strong className="text-alphaGold" data-id="element-32">
                más de 200 clientes satisfechos
              </strong>{' '}
              en todo Uruguay, seguimos creciendo gracias a la confianza de
              quienes eligen entrenar con los mejores suplementos al mejor
              precio.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-5" data-id="element-33">
            <div className="bg-dark-600 border border-dark-300 rounded-lg p-6 text-center" data-id="element-34">
              <Users className="w-8 h-8 text-alphaGold mx-auto mb-3" data-id="element-35" />
              <span className="text-[2rem] font-black text-alphaGold block" data-id="element-36">
                200+
              </span>
              <span className="text-[0.8rem] text-[#888] uppercase tracking-[1px]" data-id="element-37">
                Clientes Satisfechos
              </span>
            </div>
            <div className="bg-dark-600 border border-dark-300 rounded-lg p-6 text-center" data-id="element-38">
              <Target className="w-8 h-8 text-alphaGold mx-auto mb-3" data-id="element-39" />
              <span className="text-[2rem] font-black text-alphaGold block" data-id="element-40">
                100%
              </span>
              <span className="text-[0.8rem] text-[#888] uppercase tracking-[1px]" data-id="element-41">
                Productos Originales
              </span>
            </div>
            <div className="bg-dark-600 border border-dark-300 rounded-lg p-6 text-center" data-id="element-42">
              <Award className="w-8 h-8 text-alphaGold mx-auto mb-3" data-id="element-43" />
              <span className="text-[2rem] font-black text-alphaGold block" data-id="element-44">
                Top
              </span>
              <span className="text-[0.8rem] text-[#888] uppercase tracking-[1px]" data-id="element-45">
                Marcas Certificadas
              </span>
            </div>
            <div className="bg-dark-600 border border-dark-300 rounded-lg p-6 text-center" data-id="element-46">
              <Heart className="w-8 h-8 text-alphaGold mx-auto mb-3" data-id="element-47" />
              <span className="text-[2rem] font-black text-alphaGold block" data-id="element-48">
                24hs
              </span>
              <span className="text-[0.8rem] text-[#888] uppercase tracking-[1px]" data-id="element-49">
                Atención por WhatsApp
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}